<template>
  <b-container fluid>
    <div>
    <h1>Comprobantes de Pago</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getAllPayments"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(acciones)="row">
        <!--<router-link size="sm" :to="{name:'postFranchisesPayments', params:{id:row.item.id}}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>-->
        <b-button class="btn-sm" variant="outline-danger" v-b-modal.modal-prevent-closing @click="getIdRow({id:row.item.fileUrl})">Ver Comprobante</b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
  </b-container>
</template>

<script>
import gql from 'graphql-tag'
// import { encrypt } from '@/config/headers'
import headers from '@/config/headers.js'
export default {
  data() {
    return {
      getAllPayments: [],
      fields: [
        { key: 'concesionario.name', label: 'Concesionario', sortable: true, sortDirection: 'desc' },
        { key: 'concesionario.rfc', label: 'RFC' },
        { key: 'tripsNumber', label: 'Número de Viajes' },
        { key: 'amount', label: 'Cantidad' },
        { key: 'paidBy', label: 'Pagado Por' },
        { key: 'acciones', label: 'Acciones' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      id: 0,
    }
  },
  apollo: {
    getAllPayments: {
      query: gql`query getAllPayments{
      getAllPayments{
        id
        concesionario{
        id
        name
        rfc
        }
        fileUrl
        tripsNumber
        amount
        paidBy
      }
     }`,
      context: headers(),
      error (erro) {
        console.log('Un error')
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log('Ll')
        if (data.getAllPayments) {
          this.totalRows = data.getAllPayments.length
        }
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getIdRow(id) {
      window.open(id.id, 'blank')
    },
  },
}
</script>

<style>

</style>
